/**
 * Bridges `shopify:cart:lines-update` events from <add-to-cart> to this Dawn-based theme's cart UI.
 *
 * Event-driven themes like Horizon update their cart components from the event themselves. Dawn's
 * cart drawer and notification don't, so this renders them and republishes to the theme's pubsub.
 * Remove it once the cart listens to standard events on its own.
 */
document.addEventListener('shopify:cart:lines-update', (event) => {
  if (event.detail?.source !== 'add-to-cart') return;

  const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  cart?.setActiveElement(document.activeElement);

  event.promise
    .then(({ cart: cartSummary, detail }) => {
      if (detail.didError) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'add-to-cart',
          productVariantId: detail.variantId,
          errors: detail.errors,
          message: detail.message,
        });
        return;
      }

      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'add-to-cart',
        productVariantId: detail.variantId,
        cartData: { item_count: cartSummary.totalQuantity, items: detail.items },
      });
      cart.classList.remove('is-empty');
      cart.renderContents({ id: detail.variantId, key: detail.lineKey, sections: detail.sections });
    })
    // Failed requests are reported through `shopify:cart:error`
    .catch(() => {});
});
